import axios from 'axios';
import { IInitializePaymentRequest, ErrorType } from '../../shared/types';
import { InitializePayment } from '../contracts';
import LogCannon from '@ace-clublabs/log-cannon';
import CookieHelper from '../../utils/cookieHelper';
import { createAxiosConfig } from '../mockHelper';

export const InitializePaymentApi =
  (endpoint: string): InitializePayment =>
  async (request: IInitializePaymentRequest) => {
    try {
      const scenario = CookieHelper.getCookie('scenario');
      LogCannon.blast('InitializePaymentApi scenario', { scenario });
      LogCannon.blast('InitializePaymentApi start', { endpoint });
      const { data } = await axios.post(endpoint, request, createAxiosConfig(scenario, endpoint));
      LogCannon.blast('InitializePaymentApi success');
      return Promise.resolve(data);
    } catch (error: any) {
      LogCannon.error('InitializePaymentApi error', error);
      return Promise.reject({
        message: 'Unable to initialize payment',
        type: ErrorType.SYSTEM_ERROR,
      });
    }
  };
